import type { EditorState } from "@tiptap/pm/state";

const WORD_CHAR_RE = /[\p{L}\p{N}_]/u;

export function getWordRangeAt(
  state: EditorState,
  pos: number,
): { from: number; to: number } | null {
  const $pos = state.doc.resolve(pos);
  if (!$pos.parent.isTextblock) {
    return null;
  }

  const blockStart = $pos.start();
  const blockEnd = $pos.end();

  let from = pos;
  let to = pos;

  while (from > blockStart && WORD_CHAR_RE.test(state.doc.textBetween(from - 1, from))) {
    from -= 1;
  }

  while (to < blockEnd && WORD_CHAR_RE.test(state.doc.textBetween(to, to + 1))) {
    to += 1;
  }

  if (from === to) {
    return null;
  }

  return { from, to };
}
